import { UnfoldMore } from '@interhyp/platform-icons';
import classNames from 'classnames';
import React from 'react';
import { DropdownToolbarItem } from "./DropdownToolbarItem.js";
import { DropdownOption } from "../../dropdownWrapper/components/dropdownOption/DropdownOption.js";
import { defaultFontSizes } from "../defaults/defaultFontSizes.js";
import styles from "./TextSizeToolbarItem.module.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function TextSizeToolbarItem({
  sizes = defaultFontSizes,
  active,
  action,
  disabled,
  title = 'Schriftgröße'
}) {
  return /*#__PURE__*/_jsx(DropdownToolbarItem, {
    activeItem: active.toString(),
    content: "CUSTOM",
    disabled: disabled,
    useChildAsButton: true,
    options: /*#__PURE__*/_jsx(_Fragment, {
      children: sizes.map(size => /*#__PURE__*/_jsx(DropdownOption, {
        label: `${size.toLocaleString()} pt`,
        onClick: () => action?.(size, `${size.toLocaleString()}pt`)
      }, size))
    }),
    icon: /*#__PURE__*/_jsxs("span", {
      className: classNames(styles.textSizeItem, {
        [styles.disabled]: disabled
      }),
      title: title,
      children: [active.toLocaleString(), " ", /*#__PURE__*/_jsx(UnfoldMore, {})]
    })
  });
}